/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * a Data upload error
 * @export
 * @interface InternalApiDataUploadError
 */
export interface InternalApiDataUploadError {
    /**
     * 
     * @type {InternalApiDataUploadErrorNameEnum}
     * @memberof InternalApiDataUploadError
     */
    name: InternalApiDataUploadErrorNameEnum;
    /**
     * 
     * @type {string}
     * @memberof InternalApiDataUploadError
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiDataUploadError
     */
    field?: string;
    /**
     * 
     * @type {number}
     * @memberof InternalApiDataUploadError
     */
    row?: number;
    /**
     * 
     * @type {string}
     * @memberof InternalApiDataUploadError
     */
    actualValue?: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiDataUploadError
     */
    expectedFormat?: string;
}

/**
* @export
* @enum {string}
*/
export enum InternalApiDataUploadErrorNameEnum {
    MANDATORY_FIELD_VALUE_MISSING = 'MANDATORY_FIELD_VALUE_MISSING',
    A_NUMBER_EXPECTED = 'A_NUMBER_EXPECTED',
    INVALID_DATE_VALUE = 'INVALID_DATE_VALUE',
    INVALID_DATE_FORMAT = 'INVALID_DATE_FORMAT',
    INVALID_DATETIME_VALUE = 'INVALID_DATETIME_VALUE',
    FOUND_NO_DATA_TO_UPLOAD = 'FOUND_NO_DATA_TO_UPLOAD',
    INVALID_SHAPE = 'INVALID_SHAPE',
    MANDATORY_COLUMN_MISSING = 'MANDATORY_COLUMN_MISSING',
    EXPECTED_FIELD_VALUE_INVALID = 'EXPECTED_FIELD_VALUE_INVALID',
    NOT_ALLOWED_FIELD_TYPE = 'NOT_ALLOWED_FIELD_TYPE',
    UNSPECIFIED_ERROR = 'UNSPECIFIED_ERROR',
    ILLEGAL_VALUE = 'ILLEGAL_VALUE',
    RELATION_NOT_EXIST = 'RELATION_NOT_EXIST'
}


/**
 * Check if a given object implements the InternalApiDataUploadError interface.
 */
export function instanceOfInternalApiDataUploadError(value: object): value is InternalApiDataUploadError {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function InternalApiDataUploadErrorFromJSON(json: any): InternalApiDataUploadError {
    return InternalApiDataUploadErrorFromJSONTyped(json, false);
}

export function InternalApiDataUploadErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiDataUploadError {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'message': json['message'],
        'field': json['field'] == null ? undefined : json['field'],
        'row': json['row'] == null ? undefined : json['row'],
        'actualValue': json['actualValue'] == null ? undefined : json['actualValue'],
        'expectedFormat': json['expectedFormat'] == null ? undefined : json['expectedFormat'],
    };
}

export function InternalApiDataUploadErrorToJSON(json: any): InternalApiDataUploadError {
    return InternalApiDataUploadErrorToJSONTyped(json, false);
}

export function InternalApiDataUploadErrorToJSONTyped(value?: InternalApiDataUploadError | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'message': value['message'],
        'field': value['field'],
        'row': value['row'],
        'actualValue': value['actualValue'],
        'expectedFormat': value['expectedFormat'],
    };
}

